<template>
  <div />
</template>

<script>
export default {
  name: 'LoginByGoogle'
}
</script>

<style scoped>

</style>
